var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barracor"},[_c('p',{staticClass:"text-center bronze"},[_vm._v("Lucchese Computação e Estatística Ltda. © 2020")])])}]

export { render, staticRenderFns }